import React, { Fragment } from 'react'
import styled, { css } from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import tickIcon from '../../components/Icons/tick-icon.svg'
import { PASSWORD_REGEX } from '../../utils/validations/validations'

const P = styled.p`
  margin: 0;
  ${ifProp('pass', css`
    color: #53b260;
  `)}
`
const List = styled.ul`
  margin: .5em 0;
  padding: 0;
  list-style: none;
`
const ListItem = styled.li`
  position: relative;
  margin-bottom: .25em;
  padding-left: 1.5em;

  &::before {
    content: ${ifProp('pass', '""', '"•"')};
    position: absolute;
    left: .25em;
    width: 1em;
    height: 1em;
    text-align: center;
    ${ifProp('pass', css`
      background: url(${tickIcon}) center no-repeat;
      background-size: 90%;
    `)}
  }
  ${ifProp('pass', css`
    color: #53b260;
  `)}
`

function PasswordTip({ value }) {
  const NUMBER_REGEX = /\d+/g
  const UPPER_REGEX = /[A-Z]+/g
  const LOWER_REGEX = /[a-z]+/g
  const SPECIAL_REGEX = /[\W_]+/g

  return (
    <Fragment>
      <P pass={PASSWORD_REGEX.test(value)}>La contraseña debe tener al menos 8 caracteres y cumplir 3 de las siguientes condiciones:</P>
      <List>
        <ListItem pass={NUMBER_REGEX.test(value)}>Incluir un número</ListItem>
        <ListItem pass={LOWER_REGEX.test(value)}>Incluir al menos una letra del alfabeto en minúscula</ListItem>
        <ListItem pass={UPPER_REGEX.test(value)}>Incluir al menos una letra del alfabeto en mayúscula</ListItem>
        <ListItem pass={SPECIAL_REGEX.test(value)}>Incluir algún carácter especial (!@#$*)</ListItem>
      </List>
    </Fragment>
  )
}

export default PasswordTip
